<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>Activity</md-icon>
          </div>
          <h4 class="title">Add Staff</h4>
        </md-card-header>

        <form @submit.prevent="add">
          <md-card-content>
            <div class="text-right">
              <md-button @click="goBack" class="md-primary md-dense">Back to List</md-button>
            </div>

            <!-- Institution -->
            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">Institution</label>
              <div class="md-layout-item">
                <select-input
                    v-model="staff.institution_id"
                    track-by="id"
                    placeholder="Select Institution"
                    :options="institutions"
                    :allow-empty="false"
                />
                <validation-error :errors="apiValidationErrors.institution_id" />
              </div>
            </div>


            <!-- Station Dropdown -->
            <div class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">Station</label>
              <div class="md-layout-item">
                <select-input
                    v-model="drop_data.station_id"
                    track-by="id"
                    placeholder="Select Station"
                    :options="stations_list"
                    :allow-empty="false"

                />
              </div>
            </div>

            <!-- Port Dropdown -->
            <div class="md-layout" v-if="drop_data.station_id">
              <label class="md-layout-item md-size-25 md-form-label">Port</label>
              <div class="md-layout-item">
                <select-input
                    v-model="drop_data.port_id"
                    track-by="id"
                    placeholder="Select Port"
                    :options="ports_list"
                    :allow-empty="false"
                />
              </div>
            </div>

            <!-- Department Dropdown -->
            <div class="md-layout" v-if="drop_data.port_id">
              <label class="md-layout-item md-size-25 md-form-label">Department</label>
              <div class="md-layout-item" >
                <select-input
                    v-model="staff.department_id"
                    track-by="id"
                    placeholder="Select Department"
                    :options="departments_list"
                    :allow-empty="false"
                />
              </div>
            </div>

            <!-- Basic Fields -->
            <div v-for="(label, key) in {
                check_no: 'Check Number',
                first_name: 'First Name',
                middle_name: 'Middle Name',
                last_name: 'Last Name',
              }"
                 :key="key"
                 class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">{{ label }}</label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="staff[key]" />
                  <validation-error :errors="apiValidationErrors[key]" />
                </md-field>
              </div>
            </div>

            <!-- Gender -->
            <div class="md-layout spacing" style="overflow: visible !important;">
              <label class="md-layout-item md-size-25 md-form-label">Gender</label>
              <div class="md-layout-item" style="overflow: visible !important;">
                <select-input
                    v-model="staff.gender"
                    track-by="name"
                    placeholder="Select Gender"
                    :options="options"
                    :allow-empty="false"
                />
                <validation-error :errors="apiValidationErrors.gender" />
              </div>
            </div>
            <!-- Basic Fields -->
            <div v-for="(label, key) in {

                email: 'Email',
                phone_number: 'Phone Number',
                nida_number: 'NIDA Number'
              }"
                 :key="key"
                 class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">{{ label }}</label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="staff[key]" />
                  <validation-error :errors="apiValidationErrors[key]" />
                </md-field>
              </div>
            </div>

          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button type="submit" class="md-success">Add Staff</md-button>
          </md-card-actions>
        </form>
      </md-card>
    </div>
  </div>
</template>

<script>
import SelectInput from '@/components/Inputs/SelectInput';
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { SelectInput, ValidationError },
    mixins: [formMixin],

    data: () => ({
        staff: {
            type: 'staffs',
            check_no: null,
            gender: null,
            institution_id: null,
            email: null,
            phone_number: null,
            nida_number: null,
            department_id: null,
        },
        drop_data: {
            station_id: null,
            port_id: null,
        },
        departments_list: [],
        institutions: [],
        ports_list: [],
        stations_list: [],
        options: [
            { id: 'Female', name: 'Female' },
            { id: 'Male', name: 'Male' },
        ],
        optionsStation: [
            { id: '0616f781-9136-49f6-97d3-cad26b6f6a9f', name: 'Dar es salaam Ports' },
            { id: '151337a6-a398-4a7a-8970-e701dc7e0ea4', name: 'Lake Nyasa Ports' },
            { id: '8add65dd-aa58-487a-a9c1-faa3ab98f508', name: 'HQ' },
        ],
    }),

    created () {
        this.fetchInstitutions();
        this.getStations();
    },

    watch: {
        'drop_data.station_id' (val) {
            if (val) {
                this.getStationsPorts();
            }
        },
        'drop_data.port_id' (val) {
            if (val) {
                this.getDepartments();
            }
        }
    },

    methods: {
        async add () {
            try {
                await this.$store.dispatch('staffs/add', this.staff);
                this.staff = await this.$store.getters['staffs/staff'];
                await this.update();
                this.notifySuccess('Staff added successfully.');
                this.goBack();
            } catch (e) {
                if (
                    e &&
            e.response &&
            e.response.data &&
            e.response.data.errors &&
            e.response.data.errors[0]
                ) {
                    this.notifyError(e.response.data.errors[0].detail);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    this.notifyError('Oops, something went wrong!');
                }
            }
        },

        async update () {
            try {
                await this.$store.dispatch('staffs/update', this.staff);
                this.$store.dispatch('alerts/success', 'Staff account created successfully.');
                this.goBack();
            } catch (e) {
                if (
                    e &&
            e.response &&
            e.response.data &&
            e.response.data.errors &&
            e.response.data.errors[0]
                ) {
                    this.notifyError(e.response.data.errors[0].detail);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    this.notifyError('Oops, something went wrong!');
                }
            }
        },

        async fetchInstitutions () {
            await this.$store.dispatch('institutions/list');
            this.institutions = this.$store.getters['institutions/dropdown'];
        },

        async getStations () {
            await this.$store.dispatch('stations/list');
            this.stations_list = this.$store.getters['stations/dropdown'];
            console.log(this.stations_list);
        },

        async getStationsPorts () {
            console.log(this.drop_data.station_id);
            await this.$store.dispatch('stations/get', this.drop_data.station_id);
            const station = this.$store.getters['stations/station'];

            await this.$store.dispatch('stations/ports', station);
            this.ports_list = this.$store.getters['stations/dropdown'];
        },

        async getDepartments () {
            await this.$store.dispatch('ports/get', this.drop_data.port_id);
            const port = this.$store.getters['ports/port'];
            await this.$store.dispatch('ports/departments', port);
            this.departments_list = this.$store.getters['ports/dropdown'];
        },

        goBack () {
            this.$router.push({ name: 'Staffs List' });
        }
    }
};
</script>

<style lang="scss" scoped>
.spacing {
  padding-bottom: 1rem;
}
</style>
<style scoped>
/* Prevent dropdown from being clipped by layout/card */
.md-layout-item,
.md-layout,
.md-card,
.md-field {
  overflow: visible !important;
  position: relative !important;
}
</style>
